import { render } from "./EditPromotionPage.vue?vue&type=template&id=182cec98&ts=true"
import script from "./EditPromotionPage.vue?vue&type=script&lang=ts"
export * from "./EditPromotionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__